<template>

   <sdPageHeader>
      <template #title>
      <a-row :gutter="30">
        <a-col>
        <div class="product-single-description">
          <sdHeading class="product-single-title" as="h1" style="margin: 15px">
           Detail Report
          </sdHeading>
          <span style="margin: 0px; font-size: 16px; font-weight: 400">
          </span>
        </div>
        </a-col>
        </a-row>
      </template>
     
    </sdPageHeader>
     
  <Main>
  <sdCards headless v-if="loading">
        <div class="spin">
          <a-spin />
        </div>
      </sdCards>
  <sdCards headless v-else>
    <sdHeading class="product-single-title" as="h3" style="margin: 10px">
    List of Leads
    </sdHeading>
      <template v-if="selectedoption == 'Active'">
      <a-row :gutter="15" style="padding: 10px">
            
            <a-col :xs="24">
              <TopToolBox>
                <div class="product-single-description">
                  <div
                    class="
                      product-single-title
                      page-header-actions
                      product-single-description
                    "
                    style="float: right"
                  >
                    <a-button
                      class="btn-signin"
                      size="small"
                      type="default"
                      v-if="checkselected"
                      @click="bulkIgnore('B')"
                    >
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="x-circle" size="14" /> &nbsp;
                        Dismiss</span
                      >
                    </a-button>
                    
                    <a-button class="btn-signin" size="small" @click="exportToCSV()">
                      <span
                        style="
                          display: inline-flex !important;
                          align-items: center !important;
                        "
                      >
                        <sdFeatherIcons type="download" size="14" /> &nbsp;
                        Export</span
                      >
                    </a-button>
                  </div>
                  <span style="margin: 0px; font-size: 16px; font-weight: 400">
                    <br />
                  </span>
                </div>
              </TopToolBox>
            </a-col>
          </a-row> 
        <a-row :gutter="15">
          <a-col :md="24">
             <TableWrapper class="table-responsive">
              <a-table
                class="ant-table-striped"
                thead-class="greenColor"
                :data-source="TableData"
                :columns="TableColumns"
                :row-class-name="
                  (_record, index) => (index % 2 === 1 ? 'table-striped' : null)
                "
                :pagination="{
                    defaultPageSize: 10,
                    total: TableData.length,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                }"
              >
              </a-table>
            </TableWrapper>
          </a-col>
        </a-row>
      </template>
      
    </sdCards>
  </Main>
</template> 
<script>
import { ContactPageheaderStyle, Action, UserTableStyleWrapper ,ProjectSorting,TopToolBox,} from '../../style';
import { defineComponent } from 'vue';
import { Main, CardToolbox, TableWrapper,BasicFormWrapper } from '../../../styled';
import { dispatch, useStore } from 'vuex';
import { ProductCard } from "./style";
import { defineAsyncComponent, computed, reactive, ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { message, Notification } from 'ant-design-vue'; 
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default defineComponent({
  name: 'CallDetailReport',
  components: {
    Main,
    CardToolbox,
    BasicFormWrapper,
    UserTableStyleWrapper,
    TableWrapper,ProjectSorting,TopToolBox,ProductCard,
  },
  setup() {
    var loading = ref(true);
    var branchData = ref();
    var sourceData = ref();
    var userData = ref();
    var industryData = ref();
    var checkselected = ref(false);
    var selectcount = ref(null);
    var selectedid = ref(null);
    var selectedoption = ref('Active');
    var selectrange = ref(null);
    var dispInterest = ref(false);
    var dispProb = ref(false);

    const { dispatch, state } = useStore();
    const route = useRoute();
    const selectedChange = ref(null);
    const selectedChange1 = ref(null);
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT; 
    state.CurrentData.data = [];
    onMounted(() => {
    dailyData();
    });
    const openurl = (id) => {
      let url = '/index/';
      localStorage.setItem("clicksprint_current_route", route.fullPath);
      window.open(
          url + id +'/0',
          "_self",
      ); 
      
    };
    const dailyData = () => {
        let api_data = [];
        loading.value = true;
        api_data['status'] = route.params.status;
        api_data['user_id'] = route.query.user_id;
        //api_data['start_date'] = route.query.start_date;
        //api_data['end_date'] = route.query.end_date;
        api_data['organization'] = route.query.organization;
        //api_data['team'] = route.query.team;
        dispatch("callsDetailReport",api_data).then(
            (response) => {
                if (response.status == 200) {
                    state.CurrentData.data = response.data;
                    Notification["success"]({
                    message: "Succsess!",
                    description: "Report Loaded.",
                    });
                    loading.value = false;
                } else {
                    loading.value = false;
                    //onCancel();
                }
            },
            (error) => {
                loading.value = false;
                state.CurrentData.data = [];
                Notification["error"]({
                message: "Error!",
                description: "Error Loading Leads",
            });
          } 
          
        );
          
      }
    const TableColumns = [
      {
        title: "Lead Id",
        dataIndex: "id",
        key: "id",
        sorter: (a, b) => a.id.length - b.id.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Company",
        dataIndex: "Company",
        key: "Company",
        sorter: (a, b) => a.Company.length - b.Company.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Name",
        dataIndex: "Name",
        key: "Name",
        sorter: (a, b) => a.Name.length - b.Name.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Email",
        dataIndex: "Email_Address",
        key: "Email_Address",
        sorter: (a, b) => a.Email_Address.length - b.Email_Address.length,
        sortDirections: ["descend", "ascend"],
      },
      {
        title: "Scheduled Date",
        dataIndex: "schedule_date",
        key: "schedule_date",
        sorter: (a, b) => a.schedule_date.length - b.schedule_date.length,
        sortDirections: ["descend", "ascend"],
      },
      
      {
        title: "Amount",
        dataIndex: "opportunity_amt",
        key: "opportunity_amt",
        sorter: (a, b) => a.opportunity_amt.length - b.opportunity_amt.length,
        sortDirections: ["descend", "ascend"],
        align: "left",
      },

    ];
    
   
     let TableData = computed(() =>
        state.CurrentData.data.map((unreconcile) => {
          const {
            id,
            Company,
            Name,
            Email_Address,
            interest,
            opportunity_amt,
            Probability,
            current_status,
            user_id,
            last_action_date,
            last_action_status,
            Lead_Source,
            lead_type,
            month,
            statuses,
            schedule_date,
            } = unreconcile;
            var linedata = [];
          return {
            key: id,
            id: id,
            schedule_date:schedule_date,
            Company: (
            <div class="table-actions">
              <>
                <a style="text-align: left !important;"onClick={() => openurl(id)} to="#">
                  <span>
                    {Company}
                    </span>
                </a>
              </>
            </div>
          ),
            Name:Name,
            interest: interest,
            opportunity_amt:opportunity_amt,
            Email_Address:Email_Address,
            Probability: Probability,
            current_status: current_status,
            user_id: user_id,
            Lead_Source: Lead_Source,
            lead_type: lead_type,
            } 
            
        }
        )
    );

const exportToCSV = () => {
  const fileName = "Calls Tracking Detail Report";
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  let finalData = [];
  const borderStyle = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" }
  };

  const addCategoryHeader = (category) => {
    finalData.push([
      category, "", "", "", "", "", "", "", "", ""
    ]);
  };

  // Categorizing data
  const categorizedData = {
    TOFU: [],
    MOFU: [],
    BOFU: []
  };

  state.CurrentData.data.forEach((item) => {
    const category =
      item.Probability === "Cold"
        ? "TOFU"
        : item.Probability === "Warm"
        ? "MOFU"
        : "BOFU";

    categorizedData[category].push([
      item.id,
      item.Company,
      item.Name,
      item.Email_Address,
      item.schedule_date,
      item.opportunity_amt,
    ]);
  });

  // Adding categorized data with headers
  Object.keys(categorizedData).forEach((category) => {
    if (categorizedData[category].length > 0) {
      addCategoryHeader(category); // Section Header
      finalData = finalData.concat(categorizedData[category]); // Append Data
      finalData.push([]); // Empty row for spacing
    }
  });

  // Define column headers
  const headers = [
    ["ID","Company","Name","Email", "schedule_date","Amount"]
  ];

  // Create worksheet & apply headers
  const ws = XLSX.utils.aoa_to_sheet([...headers, ...finalData]);

  // Apply borders to all cells
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell_address = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell_address]) continue;
      ws[cell_address].s = { border: borderStyle };
    }
  }

  // Create Workbook & Export File
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sales Funnel");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);

  Notification["success"]({
    message: "Success!",
    description: "Downloaded."
  });
};
    return {
      loading,
      TableColumns,
      TableData,
      branchData,
      userData,
      sourceData,
      selectcount,
      checkselected,
      selectedoption,
      exportToCSV,
      dispInterest,
      dispProb,
      selectedChange1,
      selectedChange,
      industryData,
     };
  },
});
</script> 
<style scoped>
.ant-table-striped :deep(.table-striped) td th{
  background-color: #447316;
}
th {
  //background-color: #93BF34 !important;
}
.ant-btn-primary {
  background-color: #5C69B3 !important;
  border: 1px solid #5C69B3 !important;
}
.supp-head div{
        width: 250px;
}

.ant-col .ant-select {
  margin-top: 4px;
}
.ant-col button{
  margin-top: 5px;
}
table thead tr th:last-child {
    text-align: left !important;
}
.ant-page-header-heading {
  display: block !important;

}
</style>